<template>
  <div class="organization-select-field">
    <v-autocomplete
      class="mb-2"
      :value="value"
      :items="organizations"
      label="Юр-лицо"
      item-text="name"
      item-value="id"
      outlined
      required
      :loading="loading || listLoading"
      :disabled="loading || disabled || listLoading"
      prepend-inner-icon="mdi-account-multiple"
      no-data-text="Ничего не найдено"
      :filter="matchesSearch"
      return-object
      hide-details
      @change="emitInput"
    />
    <!--    <v-progress-linear v-if="loading || listLoading" indeterminate></v-progress-linear>-->
    <div v-if="!loading && !listLoading" :class="{ 'red--text': !isContractSigned }">
      {{ contractSignStatus }}
    </div>
  </div>
</template>

<script>
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  import { toSearchKey } from '@/util/string'

  export default {
    name: 'OrganizationSelectField',
    props: {
      value: {
        type: Number,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        listLoading: false,
        organizations: [],
      }
    },
    computed: {
      currentOrganization () {
        return this.organizations.find(item => item.id === this.value)
      },
      isContractSigned () {
        return !!this.currentOrganization?.contractSignDate
      },
      contractSignStatus () {
        if (!this.value) {
          return ''
        }

        if (!this.currentOrganization?.contractSignDate) {
          return 'Договор не подписан'
        }

        const date = new Date(this.currentOrganization.contractSignDate).toLocaleDateString(this.$i18n.locale, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })

        return `Договор подписан ${date}`
      },
    },
    created () {
      this.listLoading = true
      OrganizationDataService.getList()
        .then(res => {
          this.organizations = res
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    methods: {
      emitInput (value) {
        this.$emit('input', value ? value.id : null)
      },
      matchesSearch (item, queryText, itemText) {
        return toSearchKey(itemText).includes(toSearchKey(queryText))
      },
    },
  }
</script>
<style lang="less" scoped>
.organization-select-field {
  padding-bottom: 20px;
}
</style>
